import React, { useEffect, Fragment, useContext } from "react";
import "./envTemp.css";
import { Avatar, Grid } from "@material-ui/core/";
import * as data from "../data.json";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import DataContext from "../../DataContext"; 

 import { GenericCarbonTempAccordion } from "./carbon-temp-generic";
import { resolveTypeReferenceDirective } from "typescript";
interface IProps {
  data: CarbonTemplate;
  refreshData: ()=>void;
}
const styles = {
  tab_icon: {
    height: 120,
    width: 120,
    borderRadius: 0,
  },
};
const useStyles = makeStyles({
  root: {
    flexGrow: 1,
    maxWidth: 500,
    alignItems: "flex-start",
  },
});
interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

export const CarbonEmissionsTemplatePage: React.FC<IProps> = (props: IProps) => {
  const classes = useStyles();
  const answers = useContext(DataContext).carbonAnswers;

  const [value, setValue] = React.useState(0);
  const [sectionCompletion, setSectionCompletion] = React.useState<{
    [section: string]: number;
  }>({});
  const [render, reRender] = React.useState<boolean>(false);
    
  const addRemoveCompletion = (section: string, amount: number) => {
    sectionCompletion[section] = (sectionCompletion[section] | 0) + amount;
    setSectionCompletion(sectionCompletion);
    reRender(!render);
  };
  const handleChange = (
    event: React.ChangeEvent<Record<string, unknown>>,
    newValue: number
  ) => {
    setValue(newValue);
  };
    const [selectedTab, setSelectedTab] = React.useState<string>(Object.keys(props.data.carbonThemeDto)[0]);
    const [questionCounts, setQuestionCounts] = React.useState<{
      [section: string]: number;
    }>({});
  return (
    <div className="content_container">
      Click on an icon to begin completing the associated template or review
      previous input data.
      {/* <AppBar position="static"> */}
      <Grid
        container
        spacing={1}
        justify="space-between"
        style={{
          marginTop: 10,
          marginBottom: 5,
          width: "100%",
          marginLeft: 0,
        }}
      >
        {Object.keys(props.data.carbonThemeDto).map((tabName: string) => {
          let totalQuestions = 0;
          let totalAnswers = 0;
          Object.keys(props.data.carbonThemeDto[tabName].carbonSubThemes).forEach((section) => {
            props.data.carbonThemeDto[tabName].carbonSubThemes[section].questions.forEach((question: Question) => {
              question.choices.forEach(()=>totalQuestions = totalQuestions + 1);
              const answersForQuestion = answers.filter(x=>x.questionId === question.id && x.answer !== "");
              totalAnswers = totalAnswers + answersForQuestion.length;
            });
            const existingQuestionCounts = questionCounts;
            existingQuestionCounts[tabName] = totalQuestions;
            sectionCompletion[tabName] = totalAnswers;
            // setSectionCompletion(sectionCompletion);
            // setQuestionCounts(existingQuestionCounts);
          }
            
          );
          // let totalAnswers = 0;
          // answers.forEach((answer) => {
          //   props.data.carbonThemeDto[tabName].carbonSubThemes[section].questions.forEach(() => {
          //     totalQuestions = totalQuestions + 1;
          //   });
          //   const existingQuestionCounts = questionCounts;
          //   existingQuestionCounts[tabName] = totalQuestions;
          //   // setQuestionCounts(existingQuestionCounts);
          // }
            
          // );
          console.log(tabName);
          return (
            <Fragment key={tabName}>
              <Grid
                item
                xs={3}
                style={{
                  background: props.data.carbonStyles[tabName].themeBackground,
                  textAlign: "center",
                  color: "white",
                  // borderColor: selectedTab === tabName ? 'red' : 'white',
                  // borderBottomStyle: 'solid',
                  opacity: selectedTab === tabName ? 1 : 0.5
                }}
                key={tabName}
              onClick={()=>{setSelectedTab(tabName);}}
              >
                <img src={props.data.carbonStyles[tabName].img} style={{ width: "100px" }} />
                <div style={{ fontSize: 14 }}>{tabName}</div>
                <br/>
                <div style={{ fontSize: 10 }}>{props.data.carbonThemeDto[tabName].secondary_title}</div>

              </Grid>
            </Fragment>
          );
        })}
        
      </Grid>
      <Grid
        container
        spacing={1}
        justify="space-between"
        style={{
          marginTop: 5,
          marginBottom: 10,
          width: "100%",
          marginLeft: 0,
        }}
      >
      {Object.keys(props.data.carbonThemeDto).map((tabName: string) => {
          return (
            <Fragment key={tabName}>
              <Grid
                item
                xs={3}
                style={{
                  background: props.data.carbonStyles[tabName].themeBackground,
                  textAlign: "center",
                  color: "white",
                  borderColor: selectedTab === tabName ? 'red' : 'white',
                  borderBottomStyle: 'solid',
                  opacity: selectedTab === tabName ? 1 : 0.5
                }}
                key={tabName}
              onClick={()=>{setSelectedTab(tabName);}}
              >
                <div>{(
                    ((sectionCompletion[tabName] | 0) / questionCounts[tabName]) *
                    100
                  ).toFixed(0) + "%"}</div>
              </Grid>
            </Fragment>
          );
        })}
       </Grid>

      {/* The {selectedTab} theme comprises of {Object.keys(props.data.carbonThemeDto[selectedTab].subThemes).length} sub-themes; {" "} 
      {Object.keys(props.data.carbonThemeDto[selectedTab].subThemes).map((subTheme: string, index)=> { 
        let postText = ", "
        if(index === Object.keys(props.data.carbonThemeDto[selectedTab].subThemes).length -2){
          postText = " and ";
        } else if (index === Object.keys(props.data.carbonThemeDto[selectedTab].subThemes).length -1){
          postText = ".";
        }
        return( 
          subTheme + postText
          )
      })}
      <br/> */}
      <br/>
      Questions answered: {sectionCompletion[selectedTab] | 0} / {questionCounts[selectedTab] | 0}
      <br/>
      <br/>
      {/* </AppBar> */}
            <GenericCarbonTempAccordion
              data={props.data.carbonThemeDto[selectedTab]}
              styles={props.data.carbonStyles[selectedTab]}
              addRemoveCompletion={addRemoveCompletion}
              tabName={selectedTab}
              refreshData={props.refreshData}
            />
        
    </div>
  );
};
